import React from "react";

function DatosEmpresa(props) {
  return (
    <>
      <div className="flex flex-col overflow-x-auto pr-[0.075rem] md:pr-[0.12rem] text-[0.34rem] md:text-[0.56rem] text-textsidebar font-medium text-pretty subpixel-antialiased">
        <span className="text-[0.38rem] md:text-[0.6rem]">{props.NombreEmp}</span>
        <span>{props.NombreSede}</span>
      </div>
    </>
  );
}
export default DatosEmpresa;
